<div id="mainLoader" class="mainLoader" [ngStyle]="{ display: showLoader ? 'block' : 'none' }">
  <div class="loader-parent">
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line" [ngClass]="{ k12: productTitle === 'K12 Insight' }"></div>
    <div class="line k12" *ngIf="productTitle === 'K12 Insight'"></div>
  </div>
</div>
<div class="instructions-wrapper" *ngIf="blnShowGotiT && isOfflineEnable">
  <!-- i: intructions -->
  <div class="i-header">
    <div class="i-header-img"></div>
    <div class="i-header-text">
      <div class="i-header-small-text">Offline Participation Set-Up</div>
      <div class="i-header-big-text">{{ surveyTitle }}</div>
    </div>
  </div>

  <div class="i-body">
    <div class="i-body-text i-body-instruction">
      To collect offline responses on this device, follow the instructions below:
    </div>
    <div class="i-options-cont clearfix">
      <div class="i-option fl" [ngStyle]="{ padding: isMobile ? '' : '30px 20px 20px 103px' }">
        <div class="i-body-number"><div class="i-body-number-text">1</div></div>
        <div class="i-body-text">
          Make it easy to access this survey by adding the link to your home screen or bookmarking
          it in your browser.​
        </div>
      </div>
      <div class="i-option fl">
        <div class="i-body-number"><div class="i-body-number-text">2</div></div>
        <div class="i-body-text">Tap Record Responses to collect feedback.</div>
      </div>
      <div class="i-option fl">
        <div class="i-body-number"><div class="i-body-number-text">3</div></div>
        <div class="i-body-text">To sync responses in your account, tap Upload All Responses.</div>
      </div>
      <div class="i-option got-it fl" (click)="GotIt()">
        <div class="i-body-got-it">Let’s get started!</div>
      </div>
    </div>
  </div>

  <div class="newNoteContent">
    We recommend that you upload responses as often as possible, as only 100 responses can be stored
    within the browser memory.
  </div>
</div>

<div class="response-wrapper" *ngIf="!blnShowGotiT && isOfflineEnable">
  <!-- r: response -->
  <div class="r-header">
    <div class="r-header-img"></div>
    <div class="r-header-text">
      <div class="r-header-big-text">{{ surveyTitle }}</div>
    </div>
  </div>

  <!-- Response numbers cont -->
  <div
    class="r-numbers-cont clearfix"
    [ngClass]="OfflineResponseData.length != 1 ? 'border-top' : ''"
    [hidden]="ResponseCount == 0 && completeResponse + incompleteResponse == 0"
  >
    <div class="r-number-box fl">
      <div class="r-number-text">Responses Recorded:</div>
      <div class="r-number">{{ ResponseCount }}</div>
    </div>

    <div class="r-number-box fl">
      <div class="r-number-text">Uploads Pending:</div>
      <div class="r-number">{{ completeResponse + incompleteResponse }}</div>
    </div>
  </div>

  <div class="r-tabs-cont clearfix">
    <div class="r-tab active fl Completed" (click)="switchTabs('Completed')">
      Completed Responses
      <div class="r-tab-number">{{ completeResponse }}</div>
    </div>
    <div class="r-tab fl Incompleted" (click)="switchTabs('Incompleted')">
      Incomplete Responses
      <div class="r-tab-number">{{ incompleteResponse }}</div>
    </div>
    <div class="r-upload-cont fr" style="display: flex; align-items: center">
      <div
        *ngIf="completeResponse + incompleteResponse > 0"
        class="r-upload fr"
        value="Upload Responses"
        (click)="UploadResponses()"
        [ngStyle]="{
          'pointer-events': completeResponse + incompleteResponse == 0 ? 'none' : 'all'
        }"
      >
        <div class="r-upload-text">Upload All Responses</div>
      </div>
      <div *ngIf="completeResponse + incompleteResponse > 0" class="r-help">
        <div class="r-help-tooltip">
          We recommend that you upload responses as often as possible, as only 100 responses can be
          stored within the browser memory. Please note that internet connectivity is required to
          upload responses.
        </div>
      </div>
    </div>
  </div>

  <div class="r-empty-box" *ngIf="OfflineResponseData.length == 0">
    <div class="r-empty-img"></div>
    <div class="r-empty-text">No Responses</div>
  </div>

  <div class="r-response-body" *ngIf="OfflineResponseData.length > 0 && !isMobile">
    <table class="r-response-table" cellspacing="0" cellpadding="0">
      <tr *ngFor="let item of OfflineResponseData; let i = index">
        <td>
          <div class="response-numero">Response # {{ item.ResponseCommanData.ResponseUID }}</div>
        </td>
        <td>
          <div class="pm-time-text">
            Participation Time :
            <span class="pm-date">{{ item.ResponseCommanData.dtDispResponseStartDate }}</span>
          </div>
        </td>
        <td>
          <div class="response-actions-cont">
            <div class="response-action" title="edit" (click)="Edit(item)">Edit</div>
            <div class="response-action" title="delete" (click)="Remove(item)">Delete</div>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <div class="r-mobile-body" *ngIf="OfflineResponseData.length > 0 && isMobile">
    <div class="rm-reponse-row" *ngFor="let item of OfflineResponseData; let i = index">
      <div class="response-numero">Response {{ item.ResponseCommanData.ResponseUID }}</div>
      <div class="rm-details-actions">
        <div class="pm-time-text">
          Participation Time :
          <span class="pm-date">{{ item.ResponseCommanData.dtDispResponseStartDate }}</span>
        </div>
        <div class="response-actions-cont">
          <div class="response-action" title="edit" (click)="Edit(item)">Edit</div>
          <div class="response-action" title="delete" (click)="Remove(item)">Delete</div>
        </div>
      </div>
    </div>
  </div>

  <div class="r-btns-cont clearfix">
    <!-- Response limit handle -->
    <div
      class="fl r-record-btn"
      [ngClass]="{ disabled: OfflineResponseData.length >= 100 }"
      value="Start"
      (click)="Startsurvey()"
    >
      <div class="r-plus">+</div>
      Record New Response​
    </div>
    <div class="fl r-kiosk" style="display: none">
      <div class="r-kiosk-img"></div>
      Enter KIOSK mode
    </div>
  </div>

  <!-- Loding screen -->
  <div class="loading-wrapper" style="display: none">
    <div class="loading-progress-cont">
      <div class="loading-progress"><div class="loading-filler"></div></div>
      <div class="loading-progress-no">{{ UploadPerc }}%</div>
    </div>
    <div class="responses-completed-cont">
      <span class="completed-responses">{{ processCount }}</span> of
      <span class="total-responses">{{ prendingResponse }}</span> Responses Uploaded
    </div>
    <div class="btn-link" (click)="CancelUpload()"><a>Cancel Upload</a></div>
  </div>

  <!-- Alert -->
  <div class="alert-wrapper" *ngIf="isSomthingWrong">
    <div class="alert-cont">
      <div class="alert-img"></div>
      <div class="alert-title">Something went wrong!</div>
      <div class="alert-text">Please try uploading again...</div>
      <div class="alert-close" (click)="CloseSomthingWrong()"></div>
    </div>
  </div>
</div>

<div
  class="contact-admin-wrapper"
  [ngClass]="{ 'mobile-wrapper': isMobile, 'tablet-wrapper': isTablet }"
  *ngIf="!isOfflineEnable"
>
  <div class="contact-admin-img"></div>
  <div class="contact-admin-title">The page you are trying to access is no longer active.</div>
  <div class="contact-admin-text">
    If you feel that you are seeing this message in error, please contact the project administrator.
  </div>
  <div class="contact-admin-btn-cont">
    <input
      class="contact-admin-btn"
      type="button"
      value="Contact Account Admin"
      (click)="sendEmail()"
    />
  </div>
</div>

<div class="Plat_Alert">
  <span class="success"></span>
  <span class="spnMsg">Record updated Successfully.</span>
  <span class="closebtn" (click)="hideAlert($event.target)"></span>
</div>
